module.exports = __webpack_public_path__ + "static/temple-column-16edad2e9aece07a55ca7254bbebbe11.svg";